import React from 'react';

import Skeleton from 'components/Skeleton';

import './style.scss';

const PlaylistGroupSkeleton = () => {
  return (
    <div
      className="PlaylistGroupSkeleton"
      data-testid="playlist-group-skeleton"
    >
      <Skeleton className="h-tile w-tile" />
      <Skeleton className="my-[3px] h-[9px] w-3/5 rounded" />
      <Skeleton className="my-[3px] h-[9px] w-2/5 rounded" />
    </div>
  );
};

export default PlaylistGroupSkeleton;
